import React, { useCallback, useEffect } from 'react';
import { StyleSheet, View, Text } from 'react-native';

import {
  Advertisement,
  isAdvertisement,
  isThumbtackPro,
  isThumbtackCategory,
  Provider,
  ThumbtackPro,
  // ThumbtackCategoriesObject,
  ThumbtackHomecare,
} from '../../../api/adserver';
import config from '../../../lib/config';
import { trackAdvertView } from '../../../lib/analytics';

import CategoryAdvertListItem from '../CategoryAdvertListItem';
import ThumbtackCategoryListItem from '../CustomAdvertListItems/ThumbtackCategoryListItem';
import { ThumbtackAdvertListItemProps } from '../CustomAdvertListItems/ThumbtackAdvertListItem';
import './gridList.css';

export interface Props {
  advertCategoryList?: Advertisement[] | ThumbtackPro[];
  onPress: (
    item:
      | Advertisement
      | ThumbtackPro
      // | ThumbtackCategoriesObject
      | ThumbtackHomecare,
  ) => void;
  customListItemComponent?: React.FC<ThumbtackAdvertListItemProps>;
}

const CategoryAdvertGridList: React.FC<Props> = (props) => {
  const { advertCategoryList, customListItemComponent, onPress } = props;

  const renderItem = useCallback(
    ({
      item,
    }: {
      item:
        | Advertisement
        | ThumbtackPro
        // | ThumbtackCategoriesObject
        | ThumbtackHomecare;
    }) => {
      const renderFeatureLabel = (
        itemFeature:
          | Advertisement
          | ThumbtackPro
          // | ThumbtackCategoriesObject
          | ThumbtackHomecare,
      ) => {
        let text = 'Featured';
        if (isThumbtackPro(itemFeature)) {
          if (itemFeature.rating < 4.9) {
            return null;
          }
        } else if (isAdvertisement(itemFeature)) {
          if (!itemFeature.featured) {
            return null;
          }
          if (itemFeature.feature_type) {
            text = itemFeature.feature_type.text;
          }
        } else if (isThumbtackCategory(itemFeature)) {
          return null;
        }
        return (
          <View style={styles.featuredHeadingContainer}>
            <Text style={styles.featuredHeading}>{text}</Text>
          </View>
        );
      };
      const ListItem = () => {
        if (isThumbtackPro(item) && customListItemComponent) {
          const ThumbtackItem = customListItemComponent;
          return (
            <ThumbtackItem professional={item} onPress={onPress} margin={0} />
          );
        } else if (isThumbtackCategory(item)) {
          return (
            <ThumbtackCategoryListItem category={item} onPress={onPress} />
          );
        } else if (isAdvertisement(item)) {
          return (
            <CategoryAdvertListItem
              advert={item}
              onPress={onPress}
              margin={0}
            />
          );
        } else {
          return <Text>invalid data</Text>;
        }
      };
      console.log(`rendering grid item id ${item.id}`);
      return (
        <div className="categoryAdvertListItem" key={item.id}>
          {ListItem()}
          {renderFeatureLabel(item)}
        </div>
      );
    },
    [onPress, customListItemComponent],
  );

  const handleViewableItemsChanged = useCallback(
    ({ changed }: { changed: any[] }) => {
      // debug(viewableItems);
      // debug(changed);
      changed
        .filter((view) => view.isViewable && view.item && view.item.campaign)
        .forEach((view) => {
          setTimeout(() => {
            trackAdvertView(view.item);
          });
        });
    },
    [],
  );

  // track all adverts for this list
  useEffect(() => {
    if (advertCategoryList) {
      const advertArray = Object.keys(advertCategoryList).map(
        (k: any) => advertCategoryList[k],
      );
      advertArray.forEach((item, i) => {
        if (item.kind !== Provider.Thumbtack && item.campaign) {
          setTimeout(() => {
            trackAdvertView(item as Advertisement);
          }, 1000 * i + 1);
        }
      });
    }
  }, [advertCategoryList]);

  if (!advertCategoryList) {
    return null;
  }
  return (
    <div className="webItemList">
      {advertCategoryList.map((item) => renderItem({ item }))}
    </div>
  );
};

const maxWidth = '100%';

const styles = StyleSheet.create({
  listItem: {
    marginHorizontal: 0,
  },
  divider: {
    marginTop: 0,
  },
  featuredHeadingContainer: {
    backgroundColor: config.theme.brandColor,
    paddingStart: 18,
    paddingEnd: 31.5,
    paddingVertical: 5,
    position: 'absolute',
    right: 0,
    top: 0,
    maxWidth,
  },
  featuredHeading: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '700',
  },
  noMatches: {
    color: config.theme.headingTextColor,
    fontSize: 14,
    fontWeight: 'normal',
    textAlign: 'center',
  },
});

export default CategoryAdvertGridList;
